// extracted by mini-css-extract-plugin
export default {"error-message":"TextEditor_error-message__2dd8N","editor-container":"TextEditor_editor-container__IxLix"};